import React, { Component } from 'react' 

// redux 
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

// lib
import classnames from 'classnames'

// ui
import Button from '../../../components/uielements/button'
import { Input } from 'antd'

// icon
import { FaPlusCircle } from 'react-icons/fa'

// check permission 
import { checkCreateReportPermission } from '../../../services/check_permission/check_report'

class HeadBar extends Component {
    
    _handleAddClick = () => {
        this.props.setDefaultCurrentReport(this.props.userInfo)
        this.props.showModalReportInfo()
    }

    render(){
        const { userInfo } = this.props
        return (
            <div className={classnames('row', 'HeaderBar')}>
                <div>
                    {
                        checkCreateReportPermission(userInfo) &&
                        <Button
                            type="primary"
                            onClick={() => this._handleAddClick()}
                        >
                            <FaPlusCircle className="iconButton" />
                            Tạo báo cáo
                        </Button>
                    }
                </div>
                <div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        userInfo: state.auth.userInfo
    }
}

const mapDispacthToProps = dispatch => {
    return {
        setDefaultCurrentReport: userInfo => {
            dispatch(ReportActions.action.setDefaultCurrentReport(userInfo))
        },
        showModalReportInfo: () => {
            dispatch(ReportActions.action.showModalReportInfo())
        }
    }
}

export default connect(mapStateToProps, mapDispacthToProps)(HeadBar)